export default "__VITE_ASSET__CaUtc8ep__"